import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'formik';
import TextInput from './controls/TextInput';
import Checkbox from './controls/Checkbox';

const FormInput = ({ type, name, label, onBlur, onChange, ...props }) => (
  <Field
    name={name}
    render={({
      field: { onBlur: formikOnBlur, onChange: formikOnChange, ...field },
      form: { errors } }) => (
        <Fragment>
          {type === 'checkbox' ? (
            <Checkbox
              {...props}
              {...field}
              id={field.name}
              value={field.value || 'false'}
              checked={field.value}
              onChange={formikOnChange}
              label={label} />
          ) : (
              <TextInput
                {...props}
                {...field}
                id={field.name}
                onBlur={formikOnBlur}
                onChange={formikOnChange}
                type={type}
                value={field.value || ''} />
            )}
        </Fragment>
      )}
  />
);

FormInput.defaultProps = {
  type: "text"
};

FormInput.propTypes = {
  type: PropTypes.oneOf(["text", "number", "email", "tel", "checkbox", "password"]).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/form/FormInput.js